/** @format */

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';

import { NavLink, useLocation } from 'react-router-dom';
import { PAGES_MENU, canAccessPage } from '../../../Constants/commons';
import { useEffect, useState } from 'react';
import { useAppContext } from '../../../store/store.app';

function SidebarMenu() {
  const [activeTab, setActiveTab] = useState(0);

  const theme = useTheme();

  const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));

  const location = useLocation();

  const {
    appStore: { userInfo },
  } = useAppContext();

  const { pages } = userInfo;

  const pagesToShow = isSmallDevice
    ? PAGES_MENU.filter(
        (page) => page.enabled && page.linkText === 'home' && canAccessPage(page.linkText)
      )
    : PAGES_MENU.filter(
        (page) => page.enabled && canAccessPage(page.linkText)
      );

  function handleActiveTab() {
    const path = location.pathname.split('/')[1];

    const index = pagesToShow.findIndex((page) => page.linkText === path);

    setActiveTab(index === -1 ? 0 : index);
  }

  useEffect(() => {
    handleActiveTab();
  }, [location.pathname, isSmallDevice]);

  return (
    <List>
      {pagesToShow.map((menuItem, index) => {
        const { Icon } = menuItem;

        return (
          <NavLink
            key={menuItem.id}
            to={menuItem.linkText}
            onClick={() => setActiveTab(index)}
            style={getActiveStyle(index)}
          >
            <ListItem disablePadding>
              <ListItemButton selected={index === activeTab}>
                <ListItemIcon>
                  <Icon
                    sx={{
                      color: index === activeTab ? 'secondary.main' : 'inherit',
                    }}
                  />
                </ListItemIcon>

                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontSize: '13px',
                        textAlign: 'left',
                        overflow: 'hidden',
                      }}
                    >
                      {menuItem.displayText}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          </NavLink>
        );
      })}
    </List>
  );

  function getActiveStyle(index) {
    const color =
      activeTab === index
        ? theme.palette.text.primary
        : theme.palette.text.secondary;

    return {
      textDecoration: 'none',
      color,
    };
  }
}

export default SidebarMenu;
